import {
  CurrencyCode,
  FreightTerm,
  MoneyInput,
  PaymentTerm,
  QuoteType,
  Unit,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type QuoteLineItemInput = {
  itemId: string;
  quantity: number;
  unit: Unit;
  unitPrice: MoneyInput;
  notes?: string | null;
};

export const quoteCreateAtom = createMutationAtomFactory(
  'brokerage.quoteCreate',
  (params: {
    documentNumber: string;
    type: QuoteType;
    accountId: string;
    facilityId?: string | null;
    validUntil?: string | null;
    terms?: string | null;
    notes?: string | null;
    expectedShipDate?: string | null;
    paymentTerm?: PaymentTerm | null;
    paymentCurrency?: CurrencyCode | null;
    freightTerm?: FreightTerm | null;
    freightCoveredByCustomer?: boolean | null;
    lineItems?: QuoteLineItemInput[];
  }) => ({
    tradeQuoteCreate: {
      __args: {
        input: {
          documentNumber: params.documentNumber,
          type: params.type,
          accountId: params.accountId,
          facilityId: params.facilityId,
          validUntil: params.validUntil,
          terms: params.terms,
          notes: params.notes,
          expectedShipDate: params.expectedShipDate,
          paymentTerm: params.paymentTerm,
          paymentCurrency: params.paymentCurrency,
          freightTerm: params.freightTerm,
          freightCoveredByCustomer: params.freightCoveredByCustomer,
          lineItems: params.lineItems,
        },
      },
      id: true,
      documentNumber: true,
      status: true,
      subtotal: {
        amount: true,
        currencyCode: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
